export const TriageContent = {
  dropDownText: 'Please Select One',
  pageTitle: 'Inheriting a Vanguard account',
  pageDescription: 'In order to begin the process online, please answer a few questions.',
  continueButton: 'Continue',
  clientRadioQuestion: 'Are you a Vanguard client?',
  accountTypeDropdown: {
    question: `We'll just need to know the type of account you're transferring.`,
    label: 'Account type',
  },
  relationshipDropdown: {
    question: `How were you named or listed on the account?`,
    label: 'Relationship',
  },
  tooltips: {
    accountType:
      'We recommend taking a look at a previous statement for the person who passed away. You can find the ' +
      'account types there.',
    relationship:
      'The person who passed away managed the beneficiaries who will receive the assets. They did this by ' +
      'listing their name, relationship, or an executor. If they did not designate beneficiaries their assets will go to ' +
      'probate, and a court will determine an executor. ',
    nonretirementSpouse:
      'We need to know this information so we can provide you with all of the options available to you.',
    IRASpouse:
      'If you inherit an IRA, the IRS offers spouses additional options when transferring an IRA. So we need to ' +
      'know this information so we can provide you with all of the options available to you.',
    singleTrustee: `If there are multiple trustees, you'll be taken to a different area of Vanguard's website to complete this process`,
  },
  spouseRadioQuestion: 'Were you married to the person who passed away?',
  singleExecutorRadioQuestion: 'Are you the only executor?',
  decedentMarriedRadioQuestion: 'Was the decedent married at the time of passing?',
  executorDecedentsSpouseRadioQuestion: "Are you the decedent's spouse?",
  radioButtonHintError: 'Make a selection to continue',
  genericHintError: 'This field is required',
  trusteeOrgRadioQuestion: 'Are you representing an organization as the trustee?',
  singleTrusteeRadioQuestion: 'Are you the only trustee?',
  typeOfTrustRadioQuestion: 'What type of trust is listed as beneficiary?',
  rightRailAccordion: [
    {
      title: `What’s the difference between trust under will/testamentary and trust under agreement?`,
      content:
        `A <strong>trust under will/testamentary</strong> is a trust that is described in a will or last testament. The terms of the trust are formally established after the grantor passes away.` +
        '<br><br>' +
        `A <strong>trust under agreement</strong> (also known as a living trust, revocable trust, or trust under declaration) is a trust that was created while the grantor (person who creates the trust) was still living. `,
    },
  ],
  rightBannerTitle: 'Make sure you’re ready',
  rightBannerText:
    'Use our checklist tool to find out what info and documents you’ll need for the account types you’re inheriting.',
  rightBannerLinkText: 'Get started',
  rightBannerLink: '/document-checklist/inheritance',
};
